var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2781F156-2024-44C1-93ED-0A4573D2B999@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Standards-View",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-PSView-Project-Main-V2-FMUnavailable",
    transform: "translate(-852.000000, -307.000000)",
    fill: "#05314D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module-/-Main-Info-/-FM-Status-/-PS-/-Unavailable",
    transform: "translate(66.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FNMA-Approved-V2",
    transform: "translate(770.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,30.8 L45,36.2 L49.1,36.9 L49.1,31.5 L45,30.8 Z M46.5,32.5 L47.7,32.7 L47.7,35.1 L46.5,34.9 L46.5,32.5 Z M22.5,38 L26.4,29.2 L31.2,27.6 L31.2,22.9 L33.9,22.9 L33.9,26.6 L46.5,22.2 C42.1,31.7 32.8,37.8 22.5,38 M45,40.3 L47.6,40.8 L47.6,46.3 C46.8,45.5 46,44.7 45,44 L45,40.3 Z M47.7,20.3 L35.2,24.6 L35.2,21.4 L29.6,21.4 L29.6,26.5 L25.3,28 L21,37.8 C21.1,37.9 21.5,40.4 21.5,40.4 C32.8,37.4 44.7,42.3 50.5,52.3 L51.7,51.5 C50.9,50.2 50.1,49 49.1,47.8 L49.1,39.6 L43.6,38.6 L43.6,42.9 C39.6,40.2 35,38.5 30.3,38.2 C37.9,35.9 44.1,30.6 47.5,23.4 L53.9,38.2 L55.6,38.6 L47.7,20.3 Z M39.5,13 C26.5,13 16,23.5 16,36.5 C16,49.5 26.5,60 39.5,60 C52.5,60 63,49.5 63,36.5 C63,23.6 52.5,13 39.5,13 M39.5,14.9 C51.4,14.9 61.1,24.6 61.1,36.5 C61.1,48.4 51.5,58.1 39.5,58.1 C27.5,58.1 17.9,48.5 17.9,36.5 C17.9,24.6 27.6,14.9 39.5,14.9",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1X);
export default __webpack_public_path__ + "static/media/Shape@1x.85222db38c5d34727e20d45e19c4f7d3.svg";
export { ForwardRef as ReactComponent };